import { MapProvider } from 'react-map-gl/mapbox';

import { POIImporterProvider } from '../POIImporter/POIImporter.context';
import { Content } from './components/Content/Content';
import { MultiFlightMapProvider } from './MultiFlightMap.context';
import { MultiFlightMapStyled } from './MultiFlightMap.style';

import type { ReactNode } from 'react';
import type { AttributionSettings } from 'sonata-static-storage/lib/schemas/campaign/attributionSettings.schema';
import type { ScreenGroupInterface } from 'sonata-static-storage/lib/schemas/campaign/screenGroup.schema';
import type { ZoneGroupInterface } from 'sonata-static-storage/lib/schemas/campaign/zoneGroup.schema';
import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { Venue } from 'sonata-static-storage/lib/schemas/venue/venue.schema';
import type { SaveStepCounts, SaveStepStatus, SaveSteps } from '@/types/saveSteps.types';
import type { MapStyle } from './components/MapView/map.types';
import type { ContextDataInput, ListType, ProviderProps } from './multiFlightMap.types';

type Props = {
  attributionSettings?: AttributionSettings;
  id: string;
  isLoading: boolean;
  list: ListType;
  mapStyle?: MapStyle;
  onChangeAttributionSettings: (attributionSettings: AttributionSettings) => void;
  onChangeItems?: ProviderProps['onChangeItems'];
  onChangeScreenGroups: (screenGroups: ScreenGroupInterface[]) => void;
  onChangeZoneGroups: (zoneGroups: ZoneGroupInterface<string>[]) => void;
  onUnsavedMapChangesChange: (hasUnsavedChanges: boolean) => void;
  onSaveComplete: () => void;
  onSaveStepChange?: (step: keyof SaveSteps, status: SaveStepStatus, counts?: SaveStepCounts) => void;
  onPendingSaveStepsChange?: ProviderProps['onPendingSaveStepsChange'];
  onVenuesChange: (venues: Venue[]) => void;
  pendingToCreate?: boolean;
  saveSettings: () => void;
  setList: (list: ListType) => void;
  screenGroups?: ScreenGroupInterface[];
  shouldMapSave: boolean;
  targeting: TargetingBaseType;
  venues: Venue[];
  volumetryAndForecast?: ReactNode;
  zoneGroups: ZoneGroupInterface<string>[];
} & ContextDataInput;

function MultiFlightMap(props: Readonly<Props>) {
  return (
    <MultiFlightMapStyled>
      <MapProvider>
        <MultiFlightMapProvider mapId={`map-view-${props.entityId}`} {...props}>
          <POIImporterProvider
            COMPONENT_ID={`MultiFlightMap-${props.entityId}`}
            entity={props.entityType}
            entityId={props.entityId}
            userId={props.user._id!}
          >
            <Content
              mapId={`map-view-${props.entityId}`}
              origin={props.entityType}
              volumetryAndForecast={props.volumetryAndForecast}
            />
          </POIImporterProvider>
        </MultiFlightMapProvider>
      </MapProvider>
    </MultiFlightMapStyled>
  );
}

export default MultiFlightMap;
